import OutsideAlerter from "../elements/OutsideAlerter";

export const Dialog = (props) => {

    const { open, onClose, children } = props;

    return (
        open && (<div className="crea__dialog">
            <OutsideAlerter action={onClose}>
                {children}
            </OutsideAlerter>
            <span className="crea__dialog__background"></span>
        </div>
        )
    )
}